import React, { useEffect, useState } from 'react';
import {
  Container,
  CompletedContainer,
  ApprovedContainer,
  ResultValue,
  Heading,
  Seperator,
  NoResults,
  Loader,
  SeeMore,
} from '@app/modules/transactions/search-transaction-component';
import { useLocation } from '@app/utils';
import { useTransactionSearch } from '@app/graphql';
import { Icon } from '@app/components';

type Props = {
  showSearchTransaction: boolean;
  closeSearch: () => void;
  transactionSearchText: string;
};
type SearchResultProps = {
  currentTransactions: any;
  approvedTransactions: any;
  documents: any;
};
export default function SearchTransaction({
  showSearchTransaction,
  closeSearch,
  transactionSearchText,
}: Props) {
  const [loading, setLoading] = useState(true);
  const [pageDetails, setPageDetails] = useState({
    totalRecords: 0,
    currentPage: 0,
    totalPages: 0,
  });
  const { navigate } = useLocation();
  const [searchText, setSearchText] = useState(transactionSearchText);
  const [searchResults, setSearchResults] = useState<SearchResultProps>({
    currentTransactions: [],
    approvedTransactions: [],
    documents: [],
  });
  const [params, setParams] = useState({
    page: 1,
    limit: 20,
    search: searchText,
    offSetData: new Date().getTimezoneOffset().toString(),
  });

  const [transactionSearch] = useTransactionSearch();
  const sideNavRef: any = React.useRef(null);
  function handleClickOutside(e: any) {
    if (
      showSearchTransaction &&
      sideNavRef.current &&
      !sideNavRef.current.contains(e.target)
    ) {
      closeSearch();
    }
  }
  document.addEventListener('click', handleClickOutside);

  useEffect(() => {
    if (transactionSearchText) {
      setSearchText(transactionSearchText);
    }
  }, [transactionSearchText]);

  useEffect(() => {
    if (searchText) {
      setLoading(true);
      getTransactions(searchText);
    }
    // eslint-disable-next-line
  }, [searchText]);

  const getTransactions = (searchText: string) => {
    let transactionParams = {
      ...params,
      search: searchText,
      superAdmin: true,
    };
    transactionSearch({ variables: transactionParams })
      .then((response: any) => {
        if (response && response.data) {
          const { transactionSearch } = response.data;
          if (transactionSearch) {
            const {
              success,
              currentPage,
              totalPages,
              totalRecords,
              transaction: transactions,
            } = transactionSearch;
            if (success && transactions && transactions.length) {
              let currentTransactions = transactions.filter(
                (transaction: any) => {
                  return (
                    transaction.status !== 'APPROVED' &&
                    transaction.status !== 'UNAPPROVED'
                  );
                },
              );
              let approvedTransactions = transactions.filter((t: any) => {
                return t.status === 'APPROVED';
              });
              setParams({ ...params, page: currentPage + 1 });
              setPageDetails({
                totalPages: totalPages,
                currentPage: currentPage,
                totalRecords: totalRecords,
              });
              setSearchResults({
                currentTransactions: searchResults.currentTransactions.concat(
                  currentTransactions,
                ),
                approvedTransactions: searchResults.approvedTransactions.concat(
                  approvedTransactions,
                ),
                documents: [],
              });
            }
          }
          setLoading(false);
        }
      })
      .catch((error: any) => {
        setLoading(false);
        console.log(error);
      });
  };

  const loadMore = () => {
    getTransactions(searchText);
  };

  const getTransactionDetails = (transaction: any) => {
    closeSearch();
    navigate(`/transactions/details/${transaction.id}`);
  };

  return (
    <Container ref={sideNavRef}>
      {loading ? (
        <Loader>
          <Icon name="loader" />
        </Loader>
      ) : (
        <>
          <CompletedContainer>
            <Heading>Current Transactions</Heading>
            {searchResults.currentTransactions &&
            searchResults.currentTransactions.length ? (
              <>
                {searchResults.currentTransactions.map((cTransaction: any) => {
                  return (
                    <ResultValue
                      onClick={() => getTransactionDetails(cTransaction)}>
                      {cTransaction &&
                        `${cTransaction.property.address}, ${cTransaction.property.city}, ${cTransaction.property.state}, ${cTransaction.property.zipCode}`}
                    </ResultValue>
                  );
                })}
              </>
            ) : (
              <>
                <NoResults>No Current Transactions Found</NoResults>
              </>
            )}
            <Seperator />
          </CompletedContainer>
          <ApprovedContainer>
            <Heading>Approved Transactions</Heading>
            {searchResults.approvedTransactions &&
            searchResults.approvedTransactions.length ? (
              <>
                {searchResults.approvedTransactions.map((aTransaction: any) => {
                  return (
                    <ResultValue
                      onClick={() => getTransactionDetails(aTransaction)}>
                      {aTransaction &&
                        `${aTransaction.property.address}, ${aTransaction.property.city}, ${aTransaction.property.state}, ${aTransaction.property.zipCode}`}
                    </ResultValue>
                  );
                })}
              </>
            ) : (
              <>
                <NoResults>No Approved Transactions Found</NoResults>
              </>
            )}
          </ApprovedContainer>
        </>
      )}

      {pageDetails.currentPage < pageDetails.totalPages ? (
        <SeeMore onClick={loadMore}>See More</SeeMore>
      ) : null}
    </Container>
  );
}
